/**
 * A partner can do several kinds of work - drive a cab, fix wiring and sell
 * birds. `partnerTypes` is the list; older accounts only have `partnerType`.
 */
const ROAD = ['driver', 'courier'];

export const typesOf = (p) => {
  if (Array.isArray(p)) return p.filter(Boolean);
  const list = ((p && p.partnerTypes) || []).filter(Boolean);
  return list.length ? list : (p && p.partnerType ? [p.partnerType] : []);
};
/*
 * A restaurant, cafe, dhaba, bakery or sweet shop: anyone whose catalogue is
 * a menu. The partner type first, then the category names, so a "shop" that
 * picked the Restaurants category still gets the menu screens.
 */
const FOOD_WORDS = /restaurant|cafe|caf\u00e9|dhaba|bakery|sweet|food|tiffin|pizza|burger|biryani|chinese|fast food|juice|ice cream/i;
export const isFood = (p) => {
  if (!p) return false;
  if (typesOf(p).includes('restaurant')) return true;
  const cats = [p.primaryCategory, ...(p.categories || [])].filter(Boolean);
  return cats.some((c) => c && typeof c === 'object' && FOOD_WORDS.test(c.name || ''));
};

export const isRoad = (p) => typesOf(p).some((t) => ROAD.includes(t));
export const hasShopSide = (p) => typesOf(p).some((t) => !ROAD.includes(t));
export const courierOnly = (p) => { const t = typesOf(p); return t.includes('courier') && !t.includes('driver'); };

/*
 * Two sides of the business that cannot be mixed on one account: work done on
 * the road (rides, parcels) and work done from a shop or at the customer's
 * place. A rider may do both rides and parcels, and a shop may sell several
 * things, but nobody registers as both a cab driver and a kiryana store - the
 * screens, dispatch and categories are different.
 */
export const ROAD_TYPES = ROAD;
export const isRoadType = (t) => ROAD.includes(t);
/** Would picking `t` mix the two sides with what is already chosen? */
export const mixesSides = (selected, t) => {
  const list = (selected || []).filter(Boolean);
  const road = list.some(isRoadType);
  const shop = list.some((x) => !isRoadType(x));
  return (road && !isRoadType(t)) || (shop && isRoadType(t));
};
/** True when the two lists sit on different sides (used to reset categories). */
export const sideOf = (list) => ((list || []).some(isRoadType) ? 'road' : ((list || []).length ? 'shop' : ''));
